import {
  FETCH_DEALS,
  FETCH_DEALS_SUCCESS,
  FETCH_DEALS_ERROR,
} from '../actions/types';

//todo paginate this
const DEFAULT_STATE = {
  data: null,
  loading: false,
  saving: false,
  error: null
}

export default function(state = DEFAULT_STATE, action){
  // console.log('action received: ', action);
  switch(action.type){
    case FETCH_DEALS:
      return {
        ...state,
        data: null,
        loading: true,
        error: null,
      }
    break;
    case FETCH_DEALS_SUCCESS:
      return {
        ...state,
        data: action.payload,
        loading: false,
        error: null,
      }
    break;
    case FETCH_DEALS_ERROR:
      return {
        ...state,
        data: null,
        loading: false,
        error: action.payload
      }
    break;
  }

  return state;
}



// WEBPACK FOOTER //
// ./src/reducers/dealsReducer.js